import {useState, useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import IconButton, { iconType } from 'component/icon-button';
import LanguageSelect from 'component/select';
import {getApiMenu} from 'api/data/cms';
import './index.css';

const buttons = [
  { key: 'home', iconType: iconType.home, text: 'AnimationHeader.button_home' },
  { key: 'lottery', iconType: iconType.lottery, text: 'AnimationHeader.button_lottery' },
  { key: 'sport', iconType: iconType.sport, text: 'AnimationHeader.button_sport' },
  { key: 'game', iconType: iconType.game, text: 'AnimationHeader.button_game' },
  { key: 'sale', iconType: iconType.sale, text: 'AnimationHeader.button_sale' },
  { key: 'download', iconType: iconType.download, text: 'AnimationHeader.button_download' },
];

const HamburgerMenu = () => {
  const { t } = useTranslation();
  const activeKey = 'home';
  const currentLanguage = 'cn';
  const lanSelectOptions = [
    { text: '简体中文', value: 'zh-CN' },
    { text: '繁體中文', value: 'zh-TW' },
    { text: 'English', value: 'en-GB' }
  ];
  const [checked, setChecked] = useState(false);
  const handleChange = () => {
    setChecked(!checked);
  };
  const handleSelect = lang => {
    console.log('new language: ', lang);
  };
  // 已串接 API 要再做調整
  const [navBar, setNavBar] = useState({result:[]});
  useEffect(async() => {
     const res = await getApiMenu();
     setNavBar(res);
     console.log('get MobileNavBar:', res)
  },[])

  const entryType = [{key:0, val:'cMenu'}, {key:1, val:'hMenu'}];
  const Checkbox = ({ label, value, onChange }) => {
    return (
      <label>
        <input type="checkbox" checked={value} onChange={onChange} />
        {entryType.map(({key, val}) => <span key={key} className={val} />)}
      </label>
    );
  };
  return(
    <div className="hamburgerMenu">
      <Checkbox
           label=""
           value={checked}
           onChange={handleChange} />
           <div className="hamburgerMenuBox">
             <div className={checked.toString()}>
             <div className="functionalMobileArea">
               {buttons.map(({ key, iconType, text }) => (
                 <IconButton key={key} active={key === activeKey} iconType={iconType}>
                   {t(text)}
                 </IconButton>
                ))}
                <LanguageSelect options={lanSelectOptions} value={currentLanguage} onSelect={handleSelect} />
             </div>
             </div>
             <div className="lightBox" />
           </div>
    </div>
  )
}

export default HamburgerMenu
